/**
 * 项目默认配置项
 * primaryColor - 默认主题色
 * navTheme - sidebar theme ['dark', 'light'] 两种主题
 * colorWeak - 色盲模式
 * layout - 整体布局方式 ['sidemenu', 'topmenu'] 两种布局
 * fixedHeader - 固定 Header : boolean
 * fixSiderbar - 固定左侧菜单栏 ： boolean
 * autoHideHeader - 向下滚动时，隐藏 Header : boolean
 * contentWidth - 内容区布局： 流式 |  固定
 *
 * storageOptions: {} - Vue-ls 插件配置项 (localStorage/sessionStorage)
 *
 */

export default {
  primaryColor: '#1890FF', // primary color of ant design
  navTheme: 'dark', // theme for nav menu
  layout: 'sidemenu', // nav menu position: sidemenu or topmenu
  contentWidth: 'Fixed', // layout of content: Fluid or Fixed, only works when layout is topmenu
  fixedHeader: false, // sticky header
  fixSiderbar: false, // sticky siderbar
  autoHideHeader: false, //  auto hide header
  colorWeak: false,
  multiTab: false,
  production: process.env.NODE_ENV === 'production' && process.env.VUE_APP_PREVIEW !== 'true',
  testUrl: 'https://test-auditadmin.jgckj.com',
  proUrl: 'https://bx-auditadmin.langhuabao.com',
  bztestUrl: 'https://www-testauditadmin.get88.cn',
  bzproUrl: 'https://www-auditadmin.get88.cn',
  // baseUrl:
  storageOptions: {
    namespace: 'pro__', // key prefix
    name: 'ls', // name variable Vue.[ls] or this.[$ls],
    storage: 'local' // storage name session, local, memory
  },
  proPubKey: 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDZreMWRfMZ+t2TKpK32/b/EeiBCyvW8dfW+hoQb0a7q+O16DOjyTH+PHLXpqAu5V4Zfj4tubZukdd5sVY653SiGNRLh1KDjbdEoLfY1ZNBRWtvVfDaqrmQcYrMZkzedMuB5sHDvwYaYsr8jZ2GINeftrS8dmMf0TP2Q1QEwCl5nQIDAQAB',
  testPubKey: 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCVWRmwoFO+9PmZTm+4ZTvFacFHThfvM4PeByPFV+vn4iC9jIOJAYtcPTwhHFReDlPoOMZIPe4h4BWnvcn9P3z3/lB3Ew63NALGMshTOg7d4hz/dByAjz3mmajWdUmefHNnxgjM/PvcSvFc/xK+hQ5UFwX6q7Zk/Cs7C/hOx/964wIDAQAB'
}
